export const version: string = require('../package.json').version;
